module.exports = __webpack_public_path__ + "img/counter-ico-2.2f4b0fa2.svg";